import * as React from "react";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import { usePagination } from "common/contexts";
import {
  useGetInvestigations,
  useGetUsers,
  useGetTeams,
  useGetPriorities
} from "security-app/hooks/useInvestigationsAPI";
function CreateInvestigationNotificationDetails({
  notification
}) {
  var _a, _b;
  const { t } = useTranslation("enterprise_security_investigations");
  const localPagination = usePagination();
  const { investigations } = useGetInvestigations(localPagination);
  const investigationsMap = useMemo(
    () => Object.fromEntries(investigations.map((investigation) => [investigation.id, { label: investigation.name }])),
    [investigations]
  );
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const usersTeamsMap = useMemo(
    () => ({
      ...Object.fromEntries(users.map((user) => [user.id, { label: user.full_name, icon: "user" }])),
      ...Object.fromEntries(teams.map((team) => [team.id, { label: team.name, icon: "users" }]))
    }),
    [users, teams]
  );
  const { priorities } = useGetPriorities(true);
  const getPriorityText = useCallback(
    (value) => {
      var _a2;
      return value ? (_a2 = priorities.find((priority) => priority.priority === value)) == null ? void 0 : _a2.text : "";
    },
    [priorities]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("notification_fields.create_new_investigation"),
      value: notification.config.create_new_investigation ? /* @__PURE__ */ React.createElement("em", null, t("notification_fields.true")) : /* @__PURE__ */ React.createElement("em", null, t("notification_fields.false"))
    }
  ), !notification.config.create_new_investigation && /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("notification_fields.investigation"),
      value: (_a = investigationsMap[notification.config.investigation_id]) == null ? void 0 : _a.label
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("notification_fields.assign_to"),
      value: (_b = usersTeamsMap[notification.config.investigation_assigned_to]) == null ? void 0 : _b.label
    }
  ), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("notification_fields.priority"),
      value: getPriorityText(notification.config.investigation_priority)
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("notification_fields.status"), value: notification.config.investigation_status }));
}
export default CreateInvestigationNotificationDetails;
